import { Reveal } from "./Reveal";

const STEPS = [
  { id: "configura", num: "01", title: "Configura", text: "Crea tus empresas, locales, equipos y usuarios." },
  { id: "opera", num: "02", title: "Opera", text: "Tu equipo registra información desde celular o computador." },
  { id: "controla", num: "03", title: "Controla", text: "Revisa estados, alertas y cumplimiento." },
  { id: "mejora", num: "04", title: "Mejora", text: "Usa la información para optimizar procesos." },
];

export const HowItWorks = () => (
  <section data-testid="how-it-works-section" className="bg-[#0F4D3F] py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <Reveal>
        <p className="mb-4 text-xs font-bold uppercase tracking-[0.22em] text-[#C6F04A]/70">Cómo funciona</p>
        <h2 className="max-w-2xl text-4xl font-medium tracking-tight text-[#F3EBD7] md:text-5xl" data-testid="how-it-works-title">
          TUPU se adapta a tu operación
        </h2>
      </Reveal>

      <div className="relative mt-16 grid grid-cols-1 gap-10 md:grid-cols-4 md:gap-6">
        <div aria-hidden className="absolute left-0 right-0 top-7 hidden border-t-2 border-dashed border-[#F3EBD7]/20 md:block" />
        {STEPS.map(({ id, num, title, text }, i) => (
          <Reveal key={id} delay={i * 0.12}>
            <div data-testid={`step-${id}`} className="relative">
              <div className="relative z-10 mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-[#C6F04A] text-lg font-extrabold text-[#0F4D3F]">
                {num}
              </div>
              <h3 className="text-2xl font-semibold tracking-tight text-[#F3EBD7]">{title}</h3>
              <p className="mt-2.5 max-w-xs text-sm font-light leading-relaxed text-[#F3EBD7]/70">{text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
